import React from 'react'
import { BAlert, BCardBody, BCol, BIcon, BRow, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ReduxState } from 'app-types'

import messages from '../../i18n'
import { paymentSelectors } from '../../redux'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'

import Panel from './Components/Panel/Panel'
import sms from '../../assets/sms.svg'
import email from '../../assets/email.svg'
import tickDone from '../../assets/tickDone.svg'

import styles from './styles.scss'

interface MapStateToProps {
  amount: number
}

type Props = WizardInterface & IntlInterface & MapStateToProps

export const Final = ({ amount, translate }: Props) => (
  <>
    <BRow>
      <BCol theme="text-center">
        <img src={tickDone} alt="tickDone_icon" className={styles.tickDone_icon} />
      </BCol>
    </BRow>

    <BTitle type="h3" center>
      {translate(messages.final.title)}
    </BTitle>
    <BText center>{translate(messages.final.perex, { amount })}</BText>
    <BCardBody dark theme="my-4">
      <BTitle type="h4">{translate(messages.final.next.title)}</BTitle>
      <BText>{translate(messages.final.next.perex, { amount })}</BText>

      <BRow>
        <Panel
          icon={<img src={sms} alt="sms_icon" className={styles.sms_icon} />}
          message={messages.final.next.sms}
        />
        <Panel
          icon={<img src={email} alt="email_icon" className={styles.email_icon} />}
          message={messages.final.next.email}
        />
        <Panel icon={<BIcon name="document" size="lg" />} message={messages.final.next.ib} />
      </BRow>
    </BCardBody>
    <BAlert noIcon>{translate(messages.final.next.ib)}</BAlert>
  </>
)

const mapStateToPros = (state: ReduxState): MapStateToProps => ({
  amount: paymentSelectors.getAmount(state),
})

const enhance = compose(intl, wizard, connect(mapStateToPros))

export default enhance(Final)
